import clsx from 'clsx';
import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';

type RadioRowContentElement = ElementRef<'div'>;
type RadioRowContentProps = ComponentPropsWithoutRef<'div'>;

// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
const RadioRowContent = forwardRef<
  RadioRowContentElement,
  RadioRowContentProps
>(({ children, ...props }, forwardedRef) => {
  return (
    <div
      {...props}
      className={clsx(
        'text-grey-700 p w-full space-y-4 bg-white px-6 pb-6 sm:px-10 sm:pb-10',
        props.className,
      )}
      ref={forwardedRef}
    >
      {children}
    </div>
  );
});

RadioRowContent.displayName = 'RadioRowContent';

export { RadioRowContent };
